import BaseModel from './BaseModel'
import moment from 'moment';
import ModelArray from './ModelArray'
import AuthService from '../service/auth-service';




export default class Membership extends BaseModel {

    constructor(data) {
        super();
        this.CardNumber = data.CardNumber;
        this.Type = data.Type ;
    }

    // toJSON(){
    //     return JSON.stringify(this);
    // }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Membership.js